const getCodigoEstadoNivel1 = (paisGrupo) => {
  switch (paisGrupo) {
    case 'PY':
      return 'PY_LOCALIDADE_NIVEL_1';
    case 'AR':
      return 'AR_LOCALIDADE_NIVEL_1';
    default:
      return 'BR_LOCALIDADE_NIVEL_1';
  }
};

const findCamadaEstadoNivel1 = (layers, paisGrupo) => {
  const codigo = getCodigoEstadoNivel1(paisGrupo);
  return layers.find(l => l.codigo === codigo);
};

export default {
  findCamadaEstadoNivel1
};
